// Typelizer digest 90fc3c6fea30b8d4a2ed7e9c44d5460b
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /c/:company_id/ledger/profit_and_loss */
  show: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/ledger/profit_and_loss', {}, options),
    method: 'get',
  }),
}
